import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b17f1b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inter-bold color--text-primary fs-md" }
const _hoisted_2 = { key: 0 }

import IconButton from '@/views/V2/components/IconButton.vue';
  import { CrossIcon } from '@/views/V2/icons';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    bordered: {
      type: Boolean,
      default: true,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['onClose'],
  setup(__props, { emit }) {

  

  

  function handleOnClose() {
    emit('onClose');
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-modal-header", { 'b-modal-header--bordered': __props.bordered }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.closable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(IconButton, {
            size: "large",
            onClick: handleOnClose
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CrossIcon))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})